export class CheckAzureVMNameExists200Response {
    'exists';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "exists",
            "baseName": "exists",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CheckAzureVMNameExists200Response.attributeTypeMap;
    }
    constructor() {
    }
}
